<template>
    <div class="kgk-user-invites-list">
        <!--
        <h3>Einladung annehmen</h3>
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        -->

        <h3>Einladungen von anderen Teams</h3>
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="!invites || invites.length == 0">
            Keine Einladungen.
        </div>
        <div v-else>
            <table>
                <thead>
                    <tr>
                        <!--<td>Avatar</td>-->
                        <th>Teamname</th>
                        <th>Eingeladen von</th>
                        <th>Zeitpunkt</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invite) in invites"
                        :key="invite.identifier">
                        <td>
                            <div class="kgk-mobile-th">Teamname:</div>
                            {{ invite.team_name }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Eingeladen von:</div>
                            {{ invite.issuer_username }} ({{ invite.issuer_city }})
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Zeitpunkt:</div>
                            {{ invite.created_at }}
                        </td>
                        <td>
                            <div class="kgk-mobile-th">Aktionen:</div>
                            <div class="kgk-actions">
                                <a @click.prevent="acceptInvite(invite)" href="#" v-tooltip="'Einladung annehmen'">
                                    <i v-if="!invite.loadingAccept" class="fas fa-check fa-fw"></i>
                                    <i v-else class="fas fa-spinner fa-spin fa-fw"></i>
                                </a>
                                <a @click.prevent="declineInvite(invite)" href="#" v-tooltip="'Einladung ablehnen'">
                                    <i v-if="!invite.loadingDecline" class="fas fa-minus-circle fa-fw"></i>
                                    <i v-else class="fas fa-spinner fa-spin fa-fw"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import user from '../../api/user';

    export default {
        name: 'UserInvitesList',
        props: {

        },
        data() {
            return {
                loading: false,
                invites: []
            }
        },
        computed: {

        },
        methods: {

            acceptInvite(invite) {
                if( invite.loadingAccept ) {
                    return;
                }

                invite.loadingAccept = true;

                user.acceptInvite(
                    this,
                    invite.identifier,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Einladung angenommen',
                            text: `Du bist nun Mitglied des Teams <b>${invite.team_name}</b>.`
                        });

                        this.$emit('accepted');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => invite.loadingAccept = false
                );
            },
            declineInvite(invite) {
                if( invite.loadingDecline ) {
                    return;
                }

                invite.loadingDecline = true;

                user.declineInvite(
                    this,
                    invite.identifier,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Einladung abgelehnt',
                            text: `Du hast die Einladung des Teams <b>${invite.team_name}</b> abgelehnt.`
                        });

                        this.$emit('declined');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => invite.loadingDecline = false
                );
            },
        },
        mounted() {
            this.loading = true;

            user.getTeamInvites(
                this,
                data => {
                    this.invites = data.invites.map(invite => {
                        invite.loadingAccept = false;
                        invite.loadingDecline = false;
                        return invite;
                    });
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
</style>-->
